export const fetchUIspecChoice = `query GetUiSpecChoices {
  fetchUIspecChoice {
    uispec {
      productLine
      tabCategories {
        tabCategory
        subSections {
          subSectionId
          verticalStepperHeader
          choices {
            choiceId
            choiceName
            sequence
            lastModifiedTs
            lastModifiedBy
          }
        }
      }
    }
  }
}`;

export const CreateNewChoice = `mutation CreateChoice($input: UIspecChoiceRequest!) {
  createUIspecChoice(input: $input) {
    status
    message
    data {
      appId
      productLine
      tabCategory
      subSectionId
      choiceId
      choiceName
      uiCntrlType
      sequence
      exclFl
      itemSeqBy
      delFl
      createdTs
      createdBy
      lastModTs
      lastModBy
    }
  }
}`;

export const CreateNewSubSection = `mutation CreateSubSection($input: UIspecSubSectionRequest!) {
  createUIspecSubSection(input: $input) {
    status
    message
    data {
      appId
      productLine
      tabCategory
      subSectionId
      verticalStepperHeader
      sequence
      enableFl
      delFl
      createdTs
      createdBy
      lastModTs
      lastModBy
    }
  }
}`;

export const updateOcUiSpec = `mutation UpdateUISpec($input: UpdateUIspecRequest!) {
  updateUIspec(input: $input) {
    status
    message
    data {
      subSection {
        appId
        productLine
        tabCategory
        subSectionId
        verticalStepperHeader
        sequence
        enableFl
        delFl
        createdTs
        createdBy
        lastModTs
        lastModBy
      }
      choice {
        appId
        productLine
        tabCategory
        subSectionId
        choiceId
        choiceName
        uiCntrlType
        sequence
        exclFl
        itemSeqBy
        delFl
        createdTs
        createdBy
        lastModTs
        lastModBy
      }
    }
  }
}`;
